import { useTranslation } from "react-i18next";
import OliverText from "../OliverText";
import "./style.scss";
import classNames from "classnames";

interface NumericInputProps {
    title: string;
    value: number | string;
    callback: React.Dispatch<React.SetStateAction<number | string>> | ((value: any) => void);
    direction?: "row" | "column";
    min?: number;
    max?: number;
}

const NumericInput = ({ title, value, callback, direction, min, max }: NumericInputProps) => {
    const handleIncrease = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        const oldValue = typeof value === "number" ? value : Number(value);
        if (max && oldValue === max) return;
        callback(oldValue + 1);
        // callback(prevValue => (prevValue === "" ? 1 : Number(prevValue) + 1));
    };

    const handleDecrease = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        const oldValue = typeof value === "number" ? value : Number(value);
        if (min && oldValue === min) return;
        callback(oldValue - 1);
        // callback(prevValue => (prevValue === "" ? -1 : Number(prevValue) - 1));
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        if (newValue === "" || !isNaN(parseInt(newValue, 10))) {
            if (min && parseInt(newValue, 10) < min) return;
            if (max && parseInt(newValue, 10) > max) return;
            callback(newValue === "" ? "" : parseInt(newValue, 10));
        }
    };

    const { t } = useTranslation();

    const wrapperClass = classNames("numeric-input-wrapper", {
        [`${direction}`]: direction
    });

    return (
        <div className={wrapperClass}>
            <OliverText text={t("generalComponents.numericInput." + title)} size="xs" />
            <div className="input-wrapper">
                <input className="numeric-input" value={value} onChange={handleChange} />
                <div className="cycle-button-up" onClick={handleIncrease}>
                    <img src={"/angled-arrow-down.svg"} />
                </div>
                <div className="cycle-button-down" onClick={handleDecrease}>
                    <img src={"/angled-arrow-down.svg"} />
                </div>
            </div>
        </div>
    );
};

export default NumericInput;
